/**
 * Waits for the end of a CSS transition of the given property (with a timeout fallback)
 * @param {HTMLElement} element - Element running the transition
 * @param {string} property - Transitioned CSS property
 * @param {number} duration - Expected transition duration in ms
 * @returns {Promise<void>}
 */
export function transitionEnd(element, property, duration) {
    return new Promise(resolve => {
        let finished = false;
        const finish = () => {
            if (finished) return;
            finished = true;
            element.removeEventListener('transitionend', onEnd);
            window.clearTimeout(timeout);
            resolve();
        };
        const onEnd = event => {
            if (event.target === element && event.propertyName === property) finish();
        };
        const timeout = window.setTimeout(finish, duration + 100);
        element.addEventListener('transitionend', onEnd);
    });
}
